var attr = "id";

var getTargetOffset = function getTargetOffset(hash) {
  var id = window.decodeURI(hash.replace("#", ""));

  if (id !== "") {
    var element = document.querySelector("[".concat(attr, "=").concat(id, "]"));

    if (element) {
      return getElementTop(element);
    }
  }

  return null;
};

function getElementTop(el) {
  var actualTop = el.offsetTop;
  var current = el.offsetParent;

  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }

  return actualTop;
}

exports.onInitialClientRender = function (_, pluginOptions) {
  if (pluginOptions.offsetY) {
    attr = pluginOptions.attr;
  }

  requestAnimationFrame(function () {
    var offset = getTargetOffset(window.location.hash);

    if (offset !== null) {
      window.scrollTo(0, offset);
    }
  });
};

exports.shouldUpdateScroll = function (_ref) {
  var location = _ref.routerProps.location;
  var offset = getTargetOffset(location.hash);
  return offset !== null ? [0, offset] : true;
};